var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.visible,
          expression: "visible",
        },
      ],
      staticClass: "loading-wrap",
    },
    [
      _c(
        "div",
        { staticClass: "loading-box" },
        [
          _c("looping-rhombuses-spinner", {
            attrs: {
              "animation-duration": 2500,
              "rhombus-size": 10,
              color: "#548FC2",
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }